import {HttpRequest} from "../utils/httpRequest";

let Means = {
    /**
     * 获取数据列表
     * @param datas
     * @returns {*}
     */
    getMeansList(datas) {
        return HttpRequest.getRequest({
            url: '/edu/means/list',
            method: 'get',
            data: datas
        });
    },
    /**
     * 获取信息
     * @param id
     * @returns {*}
     */
    getMeansInfo(id) {
        return HttpRequest.getRequest({
            url: '/edu/means/info/' + id,
            method: 'get'
        });
    },
    /**
     * 添加或修改
     * @param type
     * @param datas
     * @returns {*}
     */
    addOrUpdateMeans(type, datas) {
        return HttpRequest.getRequest({
            url: '/edu/means/' + type,
            method: 'post',
            data: datas
        });
    },
    /**
     * 删除
     * @param ids
     * @returns {*}
     */
    deleteMeans(ids) {
        return HttpRequest.getRequest({
            url: '/edu/means/delete',
            method: 'get',
            data: ids
        });
    }
};
export {Means}
